module.exports = __webpack_public_path__ + "img/摄图网_500634178_banner.b2dbd46d.png";